
import React from 'react'
import './edited.scss'

export default () => (
  <svg
    className="edited-icon"
    x="0px"
    y="0px"
    viewBox="0 0 16 16"
    xmlSpace="preserve"
  >
    <path className="st0" d="M15,3.1c0.6-0.6,0.6-1.6,0-2.1s-1.6-0.6-2.1,0C10.8,3.1,4.3,9.7,2,12l-1.5,3.5L4,14.1L15,3.1z" />
    <line className="st0" x1="3" y1="10.9" x2="5.1" y2="13" />
    <polyline className="st1" points="5.5,5.5 10.4,0.6 14.6,4.9 " />
  </svg>
)
